import { render, staticRenderFns } from "./DiagnosticImageCategoryAdd.vue?vue&type=template&id=948dec1c"
import script from "./DiagnosticImageCategoryAdd.vue?vue&type=script&lang=js"
export * from "./DiagnosticImageCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports